// package/server-ee/app/react/portainer/environments/ItemView/AccessView/EnvironmentDetailsWidget.tsx

import { HardDrive } from 'lucide-react';

import { PortainerEndpointGroup } from '@api/types.gen';

import { Environment } from '@/react/portainer/environments/types';
import { stripProtocol } from '@/react/common/string-utils';

import { Link } from '@@/Link';
import { WidgetTitle, WidgetBody, Widget, Loading } from '@@/Widget';
import { Alert } from '@@/Alert';

interface Props {
  environment?: Environment;
  group?: PortainerEndpointGroup;
  error?: Error;
  isLoading: boolean;
}

export function EnvironmentDetailsWidget({
  environment,
  group,
  isLoading,
  error,
}: Props) {
  return (
    <div className="row">
      <div className="col-sm-12">
        <Widget aria-label="Environment details">
          <WidgetTitle icon={HardDrive} title="Environment" />
          <WidgetBody>
            {isLoading && <Loading />}
            {error && (
              <Alert color="error" title="Error loading environment">
                {error.message ?? 'Unknown error'}
              </Alert>
            )}
            {!isLoading && !error && environment && group && (
              <table className="table">
                <tbody>
                  <tr>
                    <td>Name</td>
                    <td>{environment.Name}</td>
                  </tr>
                  <tr>
                    <td>URL</td>
                    <td>{stripProtocol(environment.URL)}</td>
                  </tr>
                  <tr>
                    <td>Group</td>
                    <td>
                      <Link
                        to="portainer.groups.group"
                        params={{ id: group.Id }}
                        data-cy="group-link"
                      >
                        {group.Name}
                      </Link>
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
          </WidgetBody>
        </Widget>
      </div>
    </div>
  );
}
